import { gql } from "@apollo/client";

export const COUNT_NUMBER_OF_NEW_CASES_FOR_STAFF = gql`
  query GetCountNumberOfNewCasesForStaff($where: OrderWhereInput) {
    getAllOrdersForStaff(where: $where) {
      totalCount
    }
  }
`;

export const GET_ALL_ORDERS_FOR_STAFF = gql`
  query GetAllOrdersForStaff(
    $skip: Int
    $take: Int
    $where: OrderWhereInput
    $search: String
  ) {
    getAllOrdersForStaff(
      skip: $skip
      take: $take
      where: $where
      search: $search
    ) {
      orders {
        id
        orderReference
        isRush
        comment
        deliveryDate
        lastShippingDate
        status
        updatedAt
        createdAt
        isPhysicalPrint
        patientId
        userId
        addressId
        providerGroupId
        integrationType
        provider {
          id
          name
        }
        patient {
          firstName
          lastName
        }
        files {
          id
          fileType
          read
        }
        user {
          lastName
          firstName
        }
        redo {
          id
        }
        orderComment {
          translatedComment
          comment
        }
        products {
          productType
          implantItem {
            itemMaterial {
              id
              label
            }
            itemShade {
              id
              label
            }
          }
          anatomyItem {
            itemShade {
              id
              label
            }
            itemMaterial {
              id
              label
            }
            inlayCoreScanPost
            inlayCoreMaterial {
              label
            }
          }
          removableItem {
            itemMaterial {
              id
              label
            }
            teethShade {
              id
              label
            }
            gingivaShade {
              id
              label
            }
          }
        }
      }
      totalCount
    }
  }
`;

export const GET_ORDERS_SHIPPED_BACK_TO_CHINA = gql`
  query GetOrdersShippedBackToChina($where: OrderWhereInput) {
    getAllOrdersForStaff(where: $where) {
      orders {
        id
        orderReference
        shippedBackToProviderDate
      }
      totalCount
    }
  }
`;
